import { Link } from "react-router-dom";
import { Crosshair, Scan, Layers, Sparkles } from "lucide-react";
import PageHeader from "../components/PageHeader";
import Seo from "../components/Seo";

const FACTORS = [
  { icon: Crosshair, t: "Centering", d: "We measure the border ratios on the front and back. The closer to a perfect 50/50, the higher the ceiling on the grade." },
  { icon: Scan, t: "Corners", d: "Under magnification, we inspect all four corners for sharpness, fraying, or soft spots — the fastest way a grade drops." },
  { icon: Layers, t: "Edges", d: "Edges are checked for chipping, whitening, and roughness, especially on darker-bordered cards where wear shows most." },
  { icon: Sparkles, t: "Surface", d: "Print lines, scratches, dents, gloss, and staining are all assessed to judge the overall condition of the card face." },
];

export default function CardGrades() {
  return (
    <div className="bg-white" data-testid="card-grades-page">
      <Seo title="How Card Grades Are Determined" description="How a trading card grade is determined — centering, corners, edges, and surface — plus a live population count showing how rare your card's condition truly is." path="/card-grades" />
      <PageHeader eyebrow="Card grades explained" title="How a MAS grade is determined" subtitle="A grade is more than a number. Each card is judged across four independent factors, and the final grade reflects the weakest of them." />
      <section className="max-w-5xl mx-auto px-6 lg:px-8 py-20 md:py-28">
        <div className="grid md:grid-cols-2 gap-5">
          {FACTORS.map((f) => (
            <div key={f.t} className="rounded-3xl border border-neutral-200 bg-white p-8">
              <f.icon className="text-[#0A0A0A] mb-5" size={28} />
              <h3 className="font-display font-extrabold text-2xl tracking-tight text-[#0A0A0A]">{f.t}</h3>
              <p className="text-neutral-500 mt-3 leading-relaxed">{f.d}</p>
            </div>
          ))}
        </div>
        <div className="rounded-3xl bg-[#0A0A0A] text-white p-8 md:p-12 mt-6">
          <h3 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight">Why the population matters</h3>
          <p className="text-white/60 mt-4 max-w-2xl leading-relaxed">Beyond the grade, MAS tracks a live population of every identical card by grade. This shows exactly how rare your card's condition truly is — and it's verifiable by anyone at any time.</p>
          <Link to="/grading-scale" className="inline-block mt-6 font-bold text-white underline underline-offset-4">See the full grading scale →</Link>
        </div>
      </section>
    </div>
  );
}
